<template>
  <el-dialog
    title="配置数据权限"
    class="orgUpdate"
    width="30%"
    :close-on-click-modal="false"
    :visible.sync="view.visible">
    <el-radio v-model="dataAuthority" label="0">个人</el-radio>
    <el-radio v-model="dataAuthority" label="1">所在组织</el-radio>
    <el-radio v-model="dataAuthority" label="-1">所有</el-radio>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="view.visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {assignDataAuthority} from '@/controller/sys'
  export default {
    data () {
      return {
        dataAuthority: '',
        dataList: [],
        dataListSelections: [],
        dataListLoading: false,
        multiSelection: [],
        view: {
          visible: false,
          conheight: {
            height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
            'overflow-y': 'auto'
          }
        },
        viewData: {
        },
        dataForm: {
          ids: [],
          orgId: 0
        }
      }
    },
    methods: {
      init (ids) {
        this.dataForm.ids = ids
        this.view.visible = true
        this.dataAuthority = '0'
      },
      // 表格选择事件
      chooseInstance(val) {
          if (val.length > 1) {
              this.$refs.table.clearSelection()
              this.$refs.table.toggleRowSelection(val.pop())
          }
      },
      // 选择表格行，即可选中
      shopRowClick(row) {
          this.$refs.table.toggleRowSelection(row)
      },
      // 表单提交
      dataFormSubmit () {
        if (!this.dataAuthority) {
            this.$message({
                message: '请选择数据权限再提交！'
            })
            return;
        }
        assignDataAuthority(
            {
                'positionIds': this.dataForm.ids,
                'dataAuthority': this.dataAuthority
            }
        ).then(data => {
            if (data && data.code === '00') {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                        this.view.visible = false
                        this.$emit('refreshDataList')
                    }
                })
            }
        }).catch(error => {
            console.log(error)
        })
      }
    }
  }
</script>
<style lang="scss">
.orgUpdate thead .el-table-column--selection .cell{
    display: none;
}
</style>